export const env = {
    isProduction: true,
    productionURL: 'https://telawatch-logs.herokuapp.com',
    devURL: 'http://localhost:3000',
    endPoint: function (path){
        return (this.isProduction ? this.productionURL : this.devURL) + path
    }
}
